export const productVariantsTypes = ['size', 'color'];
export const productTypes = ['None', 'Set', 'Variant'];